import {
  Alert as ChakraAlert,
  AlertDescription,
  AlertProps as ChakraAlertProps,
  AlertTitle,
  Box,
  Flex,
  useTheme,
} from '@chakra-ui/react';
import * as React from 'react';
import { Icon } from '../Icon/Icon';
import { AlertProps } from './Alert.types';

export const Alert = ({
  status,
  title,
  subtitle,
  icon,
  iconClose,
  onClick,
  notClosable = false,
  titleProps = {},
  ...props
}: AlertProps & ChakraAlertProps) => {
  const { icons } = useTheme();

  const IconMap = {
    error: icons.IcDraft,
    success: icons.IcPositive,
    warning: icons.IcDraft,
    pending: icons.IcScheduled,
    feedback: icons.IcInfo,
  };

  return (
    <ChakraAlert
      variant={status}
      px={3}
      py={4}
      borderRadius={8}
      justifyContent="space-between"
      {...props}
    >
      <Flex alignItems="center">
        {status && (
          <Icon
            icon={(icon && icons[icon]) || IconMap[status]}
            mr={2}
            w={7}
            h={7}
          />
        )}
        <Box>
          <AlertTitle {...titleProps}>{title}</AlertTitle>
          {subtitle && <AlertDescription>{subtitle}</AlertDescription>}
        </Box>
      </Flex>
      {!notClosable && (
        <Icon
          w={5}
          h={5}
          icon={iconClose || icons.IcClose}
          onClick={onClick}
          p={0}
        />
      )}
    </ChakraAlert>
  );
};
